module.exports = __webpack_public_path__ + "static/media/did-you-know.68b3bca9.png";